import React, { useEffect } from 'react'
import { get } from 'libraries/lodash'
import Error from 'components/shared/Error'
import Item from 'components/legislation-reference/Item'
import url from 'front-end-core/core/url'
import { LEGISLATION } from 'constants/controllers'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

const LegislationReferences = ({ references, setHighlighted }) => {
  useEffect(() => {
    const highlightedList = []
    references.forEach(({ highlighted }) => {
      if (highlighted.length) {
        highlightedList.push(...highlighted)
      }
    })
    setHighlighted(highlightedList)
    return () => setHighlighted([])
  }, [references, setHighlighted])

  if (references.length === 0) {
    return <Error title='No data received' />
  }

  return (
    <section>
      <div className='content-view' style={{ fontSize: '10px' }}>
        {references.map(
          reference => (
            <Item key={reference.root} {...{ ...reference }} />
          )
        )}
        <div className='tc pv8 f6'>
          &copy;Crown copyright {new Date().getFullYear()}
        </div>
      </div>
    </section>
  )
}

const LegislationReferenceComponent = ({ pageToggleRight, setHighlighted, feed, aol }) => {
  const { references } = feed
  const title = get(feed, 'references[0].context[0].title', feed.title)
  const path = get(feed, 'references[0].context[0].id')
  const linkable = get(feed, 'references[0].linkable')
  const handleOnClose = () => pageToggleRight(false)

  const titleElement = linkable
    ? (
      <a
        href={url(LEGISLATION, { aol, path })}
        data-event-category='Legislation Reference'
        data-event-action='Header link'
        data-event-label={title}
        className='black no-underline hover-underline f3 pr6 fw6'
      >
        {title}
      </a>
      )
    : title

  return (
    <div>
      <section className='flex justify-between items-center bb b--grey pt7 pb6'>
        <div>
          {titleElement}
        </div>
        <IconButton
          onClick={handleOnClose}
          className='pointer black hover-cadet-blue'
          size='small'
          data-event-category='Legislation Reference'
          data-event-action='Close'
        >
          <CloseIcon />
        </IconButton>
      </section>
      <ResponseConsumer
        response={feed.references}
        content={() => <LegislationReferences {...{ references, setHighlighted }} />}
      />
    </div>
  )
}

export default LegislationReferenceComponent
